module.exports = __webpack_public_path__ + "img/Piura.9e9a6514.svg";